import * as React from "react";
import OnboardingPage from "~/components/GettingStarted/OnboardingPage";
import ExternalLink from "~/components/Navigation/ExternalLink/index";
export const DeploymentFreezeOnboardingPage = () => {
    return <OnboardingPage title="You have no deployment freezes scheduled" intro={"Add a deployment freeze to get started"} learnMore={<ExternalLink href="DeploymentFreezes">Learn more</ExternalLink>}/>;
};
